import React, { useEffect, useRef } from 'react';

// Lightweight IntersectionObserver-based reveal.
const Reveal = ({ children, className = '', delay = 0, as: Tag = 'div', once = true }) => {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => el.classList.add('in'), delay);
                        if (once) io.unobserve(el);
                    } else if (!once) {
                        el.classList.remove('in');
                    }
                });
            },
            { threshold: 0.12 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [delay, once]);

    return (
        <Tag ref={ref} className={`reveal ${className}`}>
            {children}
        </Tag>
    );
};

export default Reveal;
